export default "__VITE_ASSET__C9zxlhBu__"